import clsx from 'clsx';
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import fetchAPI from '../../../common/fetchAPI';
import { Dropdown } from 'react-bootstrap';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import Loader from '../../../common/Loader';
import { t } from 'i18next';
import parse from 'html-react-parser';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { formatCurrntDateTime, getValueFromResource } from '../../../common/timeLiveFunction';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./quill-custom.css";
import { editorToolbar } from '../../utils/PdfOrientationDropdownOptions';

const initialValues = {
    startRecord: 1,
    pageSize: 30,
    array: [],
    comments: '',
    isRelod: false,
    isLoading: true
}

const decodeHTML = (html: string) => {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
};
const cleanAndDecodeHTML = (html: string) => {
    const withoutP = html.replace(/<p[^>]*>(.*?)<\/p>/gi, '$1');
    const withoutNbsp = withoutP.replace(/&nbsp;/gi, '');
    const txt = document.createElement('textarea');
    txt.innerHTML = withoutNbsp;
    const decoded = txt.value;

    return decoded.trim();
};
const processComment = (html: string) => {
    if (!html) return '';
    const hasEncodedTags = /&lt;(table|div|tr|td|th|thead|tbody)/i.test(html);
    
    if (hasEncodedTags) {
        const withoutP = html.replace(/<p[^>]*>(.*?)<\/p>/gi, '$1');
        const withoutNbsp = withoutP.replace(/&nbsp;/gi, '');
        const txt = document.createElement('textarea');
        txt.innerHTML = withoutNbsp;
        return txt.value.trim();
    }
    
    return html;
};
const Size = Quill.import("attributors/style/size");
Size.whitelist = ["8px", "11px", "13px", "15px", "16px", "17px", "24px", "36px"];
Quill.register(Size, true);

const Font = Quill.import("attributors/class/font");
Font.whitelist = ["arial", "comic-sans", "courier-new", "georgia", "helvetica", "lucida", "tahoma", "times-new-roman", "trebuchet", "verdana"];
Quill.register(Font, true);

const AccountProjectTaskComments = (props: any) => {
    const dispatch = useAppDispatch();
    // const [taskComments, setTaskComments] = useState<any | ''>(initialValues);
    const [taskComments, setTaskComments] = useState<any>({
        startRecord: 1,
        pageSize: 30,
        array: [],
        comments: '',
        isLoading: true
    });
    const [editId, setEditId] = useState<number | null>(null);
    const [isRelod, setIsRelod] = useState(false);
    const { sessionAccountEmployeeId, cultureInfoName } = useAppSelector((state) => state.globalState);
    const { AccountProjectTaskId } = props;
    useEffect(() => {
        renderAccountProjectTaskComments();
    }, [isRelod]);

    const isEditorEmpty = (html: string) => {
        const stripped = html.replace(/<(.|\n)*?>/g, '').trim();
        return stripped === '';
    };

    useEffect(() => {
        const attachTooltips = () => {
            const items = document.querySelectorAll('.quill-wrapper .ql-toolbar button, .quill-wrapper .ql-toolbar .ql-picker');

            items.forEach((item) => {
                let title = '';
                const className = item.className;
                if (className.includes('ql-bold')) title = 'Bold';
                else if (className.includes('ql-italic')) title = 'Italic';
                else if (className.includes('ql-underline')) title = 'Underline';
                else if (className.includes('ql-strike')) title = 'Strike';
                else if (className.includes('ql-blockquote')) title = 'Blockquote';
                else if (className.includes('ql-list')) {
                    title = (item as any).value === 'ordered' ? 'Ordered List' : 'Bullet List';
                }
                else if (className.includes('ql-header')) title = 'Header Style';
                else if (className.includes('ql-font')) title = 'Font Family';
                else if (className.includes('ql-size')) title = 'Font Size';
                else if (className.includes('ql-color')) title = 'Text Color';
                else if (className.includes('ql-background')) title = 'Highlight Color';
                else if (className.includes('ql-align')) title = 'Alignment';
                else if (className.includes('ql-direction')) title = 'Text Direction';

                if (title) {
                    const translatedTitle = getValueFromResource(title, dispatch, t);
                    item.setAttribute('data-tooltip-id', 'quill-toolbar-tooltip');
                    item.setAttribute('data-tooltip-content', translatedTitle);
                }
            });
        };

        const timer = setTimeout(attachTooltips, 500);
        return () => clearTimeout(timer);
    }, [dispatch]);

    const handleEditClick = (item: any) => {
        setTaskComments({
            ...taskComments,
            comments: item.comments
        });
        setEditId(item.accountprojecttaskcommentsid);
    };

    const renderAccountProjectTaskComments = async () => {
        try {
            const response = await fetchAPI(`api/Tasks/TaskCommentData/${AccountProjectTaskId}/${taskComments.startRecord}/${taskComments.pageSize}`, 'Get', '', true);
            const json = await response.json();
            const regString: RegExp = /background-color:#([a-fA-F0-9]{6});/;
            json["data"].map((item: any) => {
                let string: string = item.EmployeeTag;
                let match: RegExpMatchArray | null = string.match(regString);
                let color: string | null = match && match[1];
                item.color = color != null ? `#${color}` : "#512DA8"
            });
            setTaskComments((prev: any) => ({
                ...prev,
                array: json["data"],
                isLoading: false
            }));
        } catch (error) {
             setTaskComments((prev: any) => ({ ...prev, isLoading: false }));
        }
    }

    const addProjectTaskComment = async () => {
        if (taskComments.comments !== '') {
            setTaskComments({
                ...taskComments,
                isLoading: true
            });
            let object = { "Comment": taskComments.comments, "AccountEmployeeId": sessionAccountEmployeeId }
            try {
                const response = await fetchAPI(`api/Tasks/${AccountProjectTaskId}/Comments`, 'Post', object, true);
                const json = await response.json();
                Number(json.id) > 0 ?
                    ShowToast('Success', json.message, "success", "toast-top-right") :
                    ShowToast('Error', "Task Comment Added Failed", "error", "toast-top-right");
                setTaskComments((prev: any) => ({ ...prev, comments: '', isLoading: true }));
                setIsRelod(prev => !prev);
                // setTaskComments({
                //     ...taskComments,
                //     comments: '',
                //     isRelod: taskComments.isRelod ? false : true,
                //     isLoading: true
                // });
            } catch (error) {

            }
        } else {
            ShowToast('Error', "The Task Comment field is required", "error", "toast-top-right");
        }
    }

    const deleteProjectTaskComment = async (id: number) => {
        ShowSwalWithConfirmation(t('Are you sure you want to delete this record?'), "")
            .then(async (result) => {
                if (result) {
                    setTaskComments({
                        ...taskComments,
                        isLoading: true
                    });
                    const response = await fetchAPI(`api/Tasks/${AccountProjectTaskId}/Comments/${id}`, 'Delete', true);
                    const json = await response.json();
                    Number(json.id) > 0 ?
                        ShowToast('Success', "Task Comment Delete Successfully", "success", "toast-top-right") :
                        ShowToast('Error', "Task Comment Delete Failed", "error", "toast-top-right");
                    setTaskComments({
                        ...taskComments,
                        isRelod: taskComments.isRelod ? false : true
                    });
                    setIsRelod(prev => !prev);
                }
            })
            .catch((error) => {
            });
    }

    const editProjectTaskComment = async (id: number) => {
        try {
            if (isEditorEmpty(taskComments.comments)) {
                ShowToast('Error', "Task Comment should not be empty.", "error", "toast-top-right");
                setTaskComments((prev: any) => ({ ...prev, comments: '' }));
                setEditId(null);
                return;
            }
            let object = {
                "Comment": taskComments.comments,
                "AccountEmployeeId": sessionAccountEmployeeId
            };
            if (taskComments.comments != '') {

                const response = await fetchAPI(`api/Tasks/${AccountProjectTaskId}/Comments/${id}`, 'POST', object, true);
                const json = await response.json();
                Number(json.id) > 0 ? ShowToast('Success', "Task Comment Updated Successfully", "success", "toast-top-right") : ShowToast('Error', "Task Comment Update Failed", "error", "toast-top-right");
                // renderAccountProjectTaskComments();
                setTaskComments((prev: any) => ({ ...prev, comments: '' }));
                setEditId(null);
                setIsRelod(prev => !prev);
            } else {
                ShowToast('Error', "Task Comment should not be empty.", "error", "toast-top-right");
                setEditId(null);
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>
            {taskComments.isLoading && <Loader />}
            <div className='row mt-6' style={{ width: '100%' }}>
                <div className='col-md-12 col-sm-12 col-xs-12'>
                    <div className='rounded' style={{ border: '1px solid #e1e3ea' }}>
                        <div className='quill-wrapper'>
                            <ReactQuill
                                theme="snow"
                                value={taskComments.comments}
                                onChange={(value) =>
                                    setTaskComments({ ...taskComments, comments: value })
                                }
                                placeholder={getValueFromResource('Enter comment', dispatch, t)}
                                modules={{
                                    toolbar: editorToolbar,
                                }}
                            />
                        </div>
                        <div style={{ float: 'inline-end' }}>
                            <button
                                className='btn btn-sm btn-primary mt-2'
                                type='button'
                                data-kt-element='send'
                                onClick={() => editId ? editProjectTaskComment(editId) : addProjectTaskComment()}
                                style={{ margin: '0px 7px 6px 0px' }}
                            >
                                {editId ? 'Update Comment' : getValueFromResource('Add Comment', dispatch, t)}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className='row mt-6' style={{ width: '100%' }}>
                <div className='col-md-12 col-sm-12 col-xs-12 mb-4'>
                    <div className='d-flex align-items-center flex-shrink-0 rounded bg-light-primary'>
                        <textarea
                            value={taskComments.comments}
                            className={"form-control"}
                            rows={4}
                            style={{ marginRight: 8, margin: '8px 8px 8px 8px', resize: 'none' }}
                            data-kt-element="input"
                            placeholder="Type a message"
                            onChange={(e) => setTaskComments({
                                ...taskComments,
                                comments: e.target.value
                            })}
                        >
                        </textarea>
                        <div>
                            <button
                                className='btn btn-sm btn-primary'
                                type='button'
                                data-kt-element='send'
                                onClick={() => addProjectTaskComment()}
                                style={{ margin: '0px 10px 72px 0px' }}
                            >
                                {'Send'}
                            </button>
                        </div>
                    </div>
                </div>
            </div> */}
            {/* className='rounded' style={{ border: '1px solid #e1e3ea', height: 166 }} bg-light-primary */}
            <div className='row mt-4 mb-5' style={{ width: '100%' }}>
                {taskComments.array.map((item: any, i: any) => (
                    <div className='col-md-12 col-sm-12 col-xs-12 mb-4' key={item.accountprojecttaskcommentsid}>
                        <div className='p-5 rounded' style={{ border: '1px solid #e1e3ea' }}>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className='d-flex align-items-center flex-shrink-0 me-5'>
                                        <div className='symbol-group symbol-hover flex-shrink-0 me-2'>
                                            <div className="symbol symbol-circle symbol-35px">
                                                <div className="symbol-label fw-bold text-inverse-warning" style={{ backgroundColor: item.color }}>
                                                    {item.firstname.split('')[0].toUpperCase() + item.lastname.split('')[0].toUpperCase()}
                                                </div>
                                            </div>
                                        </div>
                                        <a className='timeOff-hourStatus mt-3 me-4'>{`${item.firstname} ${item.lastname}`}</a>
                                        <a className='mt-1' style={{ color: '#95A5A6' }}>{` ${formatCurrntDateTime(item.ReplyAt, cultureInfoName?.toString())}`}</a>
                                        {/* <a className='mt-1' style={{ color: '#95A5A6' }}>{`Replied at ${moment(item.ReplyAt).format('M/DD/yyyy hh:mm A')}`}</a> */}
                                    </div>
                                </div>
                                <div className='col-md-6' style={{ left: 'left' }}>
                                    <span className=''>
                                        <Dropdown
                                            style={{ float: 'right' }}
                                            className={clsx('cursor-pointer symbol')}
                                            data-kt-menu-attach='parent'
                                            data-kt-menu-placement='top-start'
                                        >
                                            <Dropdown.Toggle
                                                variant="transparent"
                                                className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                data-tooltip-id="tooltip-Description"
                                                data-tooltip-content=
                                                // {t("More")}
                                                {getValueFromResource('More', dispatch, t)}
                                                data-tooltip-place="top"
                                            >
                                                <i className="bi bi-three-dots fs-2" style={{ color: '#000000' }}></i>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                <div className='menu-hover-bg-sec'>
                                                    <Dropdown.Item
                                                        className="menu-item me-lg-0"
                                                        onClick={() => handleEditClick(item)}
                                                    // onClick={() => { editProjectTaskComment(item.accountprojecttaskcommentsid) }}
                                                    >
                                                        <span className="menu-icon custom-menu mb-2">
                                                            <i className="bi bi-pencil-square fs-6 iconColor">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                        <span className="menu-title custom-menu-fontsize">{`${t('Edit')}`}</span>
                                                    </Dropdown.Item>
                                                </div>
                                                <div className='separator mb-1 mt-1 opacity-75'></div>
                                                <div className='menu-hover-bg-danger'>
                                                    <Dropdown.Item
                                                        className="menu-item me-lg-0"
                                                        onClick={() => { deleteProjectTaskComment(item.accountprojecttaskcommentsid) }}
                                                    >
                                                        <span className="menu-icon custom-menu mb-2">
                                                            <i className="bi bi-trash fs-6 delete-menu-icon-color allign">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                        <span className="menu-title delete-menu custom-menu-fontsize">
                                                            {/* {`${t('Delete')}`} */}
                                                            {getValueFromResource('Delete', dispatch, t)}
                                                        </span>
                                                    </Dropdown.Item>
                                                </div>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </span>
                                </div>
                            </div>
                            <div className='row mt-2'>
                                {/* <span style={{ marginLeft: 4 }}>
                                    {item.comments != null && parse(`${item.comments}`)}
                                </span> */}
                                <div
                                    className="comment-content"
                                    style={{ marginLeft: 4 }}
                                    dangerouslySetInnerHTML={{ __html: processComment(item.comments ?? '') }}
                                />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <ReactTooltip
                id="quill-toolbar-tooltip"
                style={{
                    fontSize: 12,
                    fontWeight: 'normal',
                    padding: 8,
                    borderRadius: 6,
                    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
                    backgroundColor: 'black',
                    color: 'white',
                    zIndex: 999999,
                    maxWidth: 220,
                    whiteSpace: 'normal'
                }}
                place="top"
                delayShow={100}
                delayHide={100}
                clickable
            />
        </>
    )

}
export default AccountProjectTaskComments